export const nextApi = [
    {
        "id": 1,
        "img": "https://lh3.googleusercontent.com/pw/AM-JKLXlcMwYp0SIXT7waX215mYfCc4kWeEvEAiUi7Ce0bVvj9OZ6BDLmmvKAQbubhXFoSNBU2qQpro3xPV8MjiwR5ZNIuhP6KHwxYuIJS3bEMnF9OOQDGk3B7ZiJRZgiAQhQtcbyNeZU3pGChwZjJlA-l9y=w818-h914-no?",
        "category": "Next Application",
        "tag": "next landing",
        "description": "No special description. But I made this through an youtube series. And it was a 3rd project from next js.. first two project was just a initialization of next.js",
        "link": "https://nextjs-landing-page-practice.netlify.app/",
    },
    // {
    //     "id": 2,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },
    // {
    //     "id": 3,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },
    // {
    //     "id": 4,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },
    // {
    //     "id": 5,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },
    // {
    //     "id": 6,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },
    // {
    //     "id": ,
    //     "img": "",
    //     "category": "Next Application",
    //     "tag": "",
    //     "description": "",
    //     "link": "",
    // },

]